import http from "./http.service";
import Promisable from "./promisable.service";
import { modalActions } from "redux/slices/modal";
import { NavigateFunction } from "react-router-dom";
import { loaderActions } from "redux/slices/loader";
import { getAppDispatch } from "utils/dispatch.util";
import { paymentLinkActions } from "redux/slices/paymentLink";
import { formLoaderActions } from "redux/slices/formLoader";
import DateService from "utils/date.util";

const url = "/payment-link";

const PaymentLinkService = {
  addPaymentLink: async (data: any, navigate?: NavigateFunction) => {
    const dispatch = getAppDispatch();
    dispatch?.(formLoaderActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/create`, data)
    );

    if (success) {
      navigate?.(`/payment-link`);

    }

    dispatch?.(formLoaderActions.setLoading(false));
    return [success, error];
  },
  updatePaymentLink: async (id: string, data: any) => {
    const updatedData: Record<string, unknown> = {
      note: data.note,
      trip_ids: data.trip_ids,
      email: data?.email,
      send_email: data?.send_email,
    };
    if (data.payment_gateway !== undefined) {
      updatedData.payment_gateway = data.payment_gateway;
    }
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.patch(`${url}/${id}`, updatedData)
    );
    if (success) {
      const { paymentLink } = success.data.data;
      dispatch?.(paymentLinkActions.updatePaymentLink({ id, paymentLink }));
      dispatch?.(paymentLinkActions.setPaymentLink(paymentLink));
      dispatch?.(modalActions.closeModal());
    }
    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  getPaymentLink: async (id: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(paymentLinkActions.setLoading(true));
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/${id}`)
    );
    if (success) {
      const { paymentLink } = success.data.data;
      dispatch?.(paymentLinkActions.setPaymentLink(paymentLink));
    } else dispatch?.(paymentLinkActions.setPaymentLink({ data: "Not Found" }));
    dispatch?.(paymentLinkActions.setLoading(false));
    return [success, error];
  },
  getAllPaymentLinks: async (data?: any) => {
    const dispatch = getAppDispatch();
    if (data?.all) dispatch?.(modalActions.setLoading(true));
    else dispatch?.(paymentLinkActions.setLoading(true));
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/all`, data)
    );
    if (success) {
      const { paymentLinks, count } = success.data.data;
      if (data?.all)
        dispatch?.(
          modalActions.updateData({
            table_data: paymentLinks.map((payment: any) => ({
              "ID": payment.doc_number,
              "Created date": DateService.getSaudiaDateAndTimeStringForExcel(payment.createdAt),
              "Created Time": DateService.getSaudiaTimeString(payment.createdAt),
              "Received date": payment.received_date ? DateService.getSaudiaDateAndTimeStringForExcel(payment.received_date) : "--",
              "Received Time": payment.received_date ? DateService.getSaudiaTimeString(payment.received_date) : "--",
              "Email": payment.email,
              "Price": parseFloat(payment.price),
              'Currency': payment.currency,
              "Booking ID": payment?.trip_ids?.map((item: any) => item?.booking_number).join(", ") || "--",
              "Payment Link": payment.link,
              "Payfort Intent": payment.isStripe ? "" : payment.payment_intent,
              "Stripe Intent": payment.isStripe ? payment.payment_intent : "",
              "Payment Method": payment.payment_method
                ? payment.isStripe
                  ? "Stripe"
                  : `${payment.payment_gateway === "HyperPay" ? "HyperPay" : "Payfort"}-${payment.payment_method}`
                : "",
              "Notes": payment.note || "",
              "Active": payment.is_active ? "Yes" : "No",
              "Payment Status": payment.status === 'refund' ? "Refunded" : payment.status,

            })),
          })
        )
      else
        dispatch?.(paymentLinkActions.setPaymentLinks({ paymentLinks, count }));
    }
    if (data?.all) dispatch?.(modalActions.setLoading(false));
    else dispatch?.(paymentLinkActions.setLoading(false));
    return [success, error];
  },
  updatePaymentLinkStatus: async (id: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/status/${id}`)
    );

    if (success) {
      const { paymentLink } = success.data.data;
      dispatch?.(paymentLinkActions.updatePaymentLink({ id, paymentLink }));
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  refundPayment: async (id: string,data: { amount: number; reason?: string }) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/refund/${id}`, data)
    );

    if (success) {
      const { paymentLink } = success.data.data;
      dispatch?.(paymentLinkActions.updatePaymentLink({ id, paymentLink }));
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
};

export default PaymentLinkService;
